import { connect } from 'react-redux'
import ServiceEditBottomBar from '../../components/services/edit/ServiceEditBottomBar'
import { IStoreState } from '../../types/index'
import { getServiceFetching, getServiceProcessing } from '../../state/reducers/services'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const currentStep = state.serviceEdit.steps.currentStep
  const serviceProcessing = getServiceProcessing(state)
  const serviceFetching = getServiceFetching(state)

  const processing = serviceProcessing || currentStep.updating
  const fetching = serviceFetching || currentStep.fetching

  return {
    onSaveClick: ownProps.onSaveClick,
    onCancelClick: ownProps.onCancelClick,
    processing,
    fetching
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceEditBottomBar)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceEditBottomBar.ts